exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".memberList .memberItem .memberShow .memberImage .imageLoadError {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: #e4e5e9;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.memberList .memberItem .memberShow .memberImage .imageLoadError .iconStyle {\n  font-size: 24px;\n  color: #999;\n}\n", ""]);

// exports
